import { createAction } from 'redux-actions'

export const openSkipConfirmationModal = createAction(
  'OPEN_SKIP_CONFIRMATION_MODAL'
)
export const closeSkipConfirmationModal = createAction(
  'CLOSE_SKIP_CONFIRMATION_MODAL'
)
